// cookieHelper.ts
import Cookies from 'js-cookie';

/**
 * Returns the environment-prefixed cookie name if REACT_APP_BRANCH_NAME is set and not "production".
 * Otherwise, returns the plain name.
 */
export function getCookieName(name: string): string {
  const branch = process.env.REACT_APP_BRANCH_NAME;
  if (branch && branch !== 'production') {
    return `${branch}_${name}`;
  }
  return name;
}

/**
 * Reads a cookie using the correct environment-prefixed name.
 */
export function getCookie(name: string): string | undefined {
  return Cookies.get(getCookieName(name));
}

/**
 * Sets a cookie using the correct environment-prefixed name.
 */
export function setCookie(name: string, value: string, options?: Cookies.CookieAttributes): void {
  Cookies.set(getCookieName(name), value, options);
}

/**
 * Removes a cookie using the correct environment-prefixed name.
 */
export function removeCookie(name: string, options?: Cookies.CookieAttributes): void {
  Cookies.remove(getCookieName(name), options);
}